import React from 'react'
import ReactJson from 'react-json-view'
import { useTranslation } from 'react-i18next'

import { JsonViewDrawerProps, CopyProps } from './JsonViewDrawer.types'
import { Drawer } from '@percent/lemonade'
import styles from './JsonViewDrawer.module.scss'
import { logger } from '@percent/admin-dashboard/common/utility/logger'

const handleCopy = async (copy: CopyProps) => {
  try {
    await navigator.clipboard.writeText(JSON.stringify(copy.src, null, '\t'))
  } catch (e) {
    logger(e)
  }
}

// The drawer is only ever opened by its callers, so it has no trigger button of its own to handle.
const noTrigger = () => undefined

export function JsonViewDrawer({ isOpen, onClose, rawJsonData }: JsonViewDrawerProps) {
  const { t } = useTranslation()

  return (
    <Drawer
      classNames={{ body: styles.drawerBody, header: styles.drawerHeader, title: styles.drawerTitle }}
      title={t('typography.details')}
      position="right"
      isOpen={isOpen}
      onClose={onClose}
      onOpen={noTrigger}
    >
      <hr className={styles.separator} />
      <ReactJson
        style={{
          paddingTop: '20px',
          wordBreak: 'break-all',
          fontSize: '14px'
        }}
        name={false}
        src={rawJsonData}
        theme="summerfruit"
        displayDataTypes={false}
        enableClipboard={handleCopy}
      />
    </Drawer>
  )
}
